import { State } from './index';
import { setUser, removeUser } from '../../helpers/storage';

export type Action =
  | { type: 'SET_LOADING'; payload: State['isLoading'] }
  | { type: 'SET_ALERT_MODAL'; payload: State['alertModal'] }
  | { type: 'SET_LOGIN_MODAL'; payload: State['loginModal'] }
  | { type: 'SET_USER'; payload: State['user'] };

export default function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_LOGIN_MODAL':
      return { ...state, loginModal: action.payload };
    case 'SET_ALERT_MODAL':
      return { ...state, alertModal: action.payload };
    case 'SET_USER':
      if (action.payload) {
        setUser(action.payload);
      } else if (action.payload === undefined) {
        removeUser();
      }

      return { ...state, user: action.payload };
    default:
      return state;
  }
}
